<template>
  <div class="p-3">
    <shared-send-message></shared-send-message>
  </div>
</template>

<script>
import SharedSendMessage from '@/views/Shared/Messages/Send'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.Messages.SMS',
  components: {
    SharedSendMessage
  },
  mounted () {
    let number = ''
    if (this.$route.params.number !== 'undefined') {
      number = this.$route.params.number
    }
    EventBus.$emit('setGivenNumber', number)
  }
}
</script>

<style scoped>

</style>
